module.exports = __webpack_public_path__ + "static/media/img-card-two.ba8ba175.jpg";